module.exports = __webpack_public_path__ + "img/service-sec01-img02.bf62a06b.png";